import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * Returns whether the Classic to Next Gen Actions Bar features should be shown: the thumbnail size slider, the
 * multi-select action bar and bulk download.
 *
 * Defaults to `false`: Collections and Assets render exactly as before until the flag is enabled.
 */
function useShowActionsBar(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.ACTIONS_BAR_FE, false);
}

export { useShowActionsBar };
